import "@/App.css";
import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import { Layout } from "./components/Layout";
import { PortalLayout } from "./components/PortalLayout";
import { Login } from "./pages/Login";
import SeleccionarPerfil from "./pages/SeleccionarPerfil";
import { Dashboard } from "./pages/Dashboard";
import { Organigrama } from "./pages/Organigrama";
import OrganigramaViewer from "./pages/OrganigramaViewer";
import CapacitacionViewer from "./pages/CapacitacionViewer";
const DocumentosViewer = React.lazy(() => import("./pages/DocumentosViewer"));
const ReporteIncidente = React.lazy(() => import("./pages/incidentes/ReporteIncidente"));
const MisIncidentes = React.lazy(() => import("./pages/incidentes/MisIncidentes"));
const HerramientasViewer = React.lazy(() => import("./pages/HerramientasViewer"));
const PerfilViewer = React.lazy(() => import("./pages/PerfilViewer"));
const LiderazgoDashboard = React.lazy(() => import("./pages/LiderazgoDashboard"));
const LiderazgoViewer = React.lazy(() => import("./pages/LiderazgoViewer"));
const CentroDatos = React.lazy(() => import("./pages/CentroDatos"));
const VerificarChecklist = React.lazy(() => import("./pages/VerificarChecklist"));
const Presentacion = React.lazy(() => import("./pages/Presentacion"));
const PaseVisita = React.lazy(() => import("./pages/PaseVisita"));
const PruebaPublica = React.lazy(() => import("./pages/PruebaPublica"));
const TutorialKeyUser = React.lazy(() => import("./pages/TutorialKeyUser"));
const ValidarPase = React.lazy(() => import("./pages/ValidarPase"));
const PasesVisitaDashboard = React.lazy(() => import("./pages/PasesVisitaDashboard"));
import { Areas } from "./pages/Areas";
import { Cargos } from "./pages/Cargos";
import { Personas } from "./pages/Personas";
import { Controles } from "./pages/Controles";
import { Capacitaciones } from "./pages/Capacitaciones";
import { Actividades } from "./pages/Actividades";
import { Reportes } from "./pages/Reportes";
import { Configuracion } from "./pages/Configuracion";
import { CargaMasiva } from "./pages/CargaMasiva";
import { Repositorio } from "./pages/Repositorio";
import { MapaAreas } from "./pages/MapaAreas";
import { Organizacion } from "./pages/Organizacion";
import Sectores from "./pages/Sectores";
import TiposActividad from "./pages/TiposActividad";
import CatalogoRecursos from "./pages/CatalogoRecursos";
import QRA from "./pages/QRA";
import { EmpresasColaboradoras } from "./pages/EmpresasColaboradoras";
import { InformeGCOM } from "./pages/InformeGCOM";
import { ReportesGCOM } from "./pages/ReportesGCOM";
import CalendarioCapacitaciones from "./pages/CalendarioCapacitaciones";
import PerfilContratista from "./pages/PerfilContratista";
import { PortalDashboard } from "./pages/portal/PortalDashboard";
import { PortalCurso } from "./pages/portal/PortalCurso";
import { PortalOrganigrama } from "./pages/portal/PortalOrganigrama";
import { PortalHistorial } from "./pages/portal/PortalHistorial";
import { PortalRepositorio } from "./pages/portal/PortalRepositorio";
import { PortalPerfil } from "./pages/portal/PortalPerfil";
const PortalInvestigaciones = React.lazy(() => import("./pages/portal/PortalInvestigaciones"));
const ImplementacionTI = React.lazy(() => import("./pages/ImplementacionTI"));
import { CapacitadorLayout } from "./components/CapacitadorLayout";
import { EquipoHsLayout } from "./components/EquipoHsLayout";
const EquipoHsEventos = React.lazy(() => import("./pages/equipo_hs/EquipoHsEventos"));
const EquipoHsCorreos = React.lazy(() => import("./pages/equipo_hs/EquipoHsCorreos"));
import ServiciosGeneralesLayout from "./components/ServiciosGeneralesLayout";
import SgDashboard from "./pages/servicios_generales/SgDashboard";
import SgContratos from "./pages/servicios_generales/SgContratos";
import SgTrabajadores from "./pages/servicios_generales/SgTrabajadores";
import SgCasino from "./pages/servicios_generales/SgCasino";
import SgHabitaciones from "./pages/servicios_generales/SgHabitaciones";
import SgCasinoKiosko from "./pages/servicios_generales/SgCasinoKiosko";
import SgReglas from "./pages/servicios_generales/SgReglas";
import SgQrHabitacion from "./pages/servicios_generales/SgQrHabitacion";
import SgPabellones from "./pages/servicios_generales/SgPabellones";
import SgPersonalSoporte from "./pages/servicios_generales/SgPersonalSoporte";
import SgCasinoMantenedor from "./pages/servicios_generales/SgCasinoMantenedor";
import SgCasinoReporte from "./pages/servicios_generales/SgCasinoReporte";
import SgTimeline from "./pages/servicios_generales/SgTimeline";
import CapacitadorCalendario from "./pages/capacitador/CapacitadorCalendario";
import CapacitadorDashboard from "./pages/capacitador/CapacitadorDashboard";
import CapacitadorReporte from "./pages/capacitador/CapacitadorReporte";
import CapacitadorCursos from "./pages/capacitador/CapacitadorCursos";
import CapacitadorEmpresas from "./pages/capacitador/CapacitadorEmpresas";
import CapacitadorReglas from "./pages/capacitador/CapacitadorReglas";
import CapacitadorBloqueados from "./pages/capacitador/CapacitadorBloqueados";
import CapacitadorUsuariosEmpresa from "./pages/capacitador/CapacitadorUsuariosEmpresa";
import CapacitadorEncuesta from "./pages/capacitador/CapacitadorEncuesta";
import { EseLayout } from "./components/EseLayout";
import EseTrabajadores from "./pages/ese/EseTrabajadores";
import EseUsuarios from "./pages/ese/EseUsuarios";
import EseSesiones from "./pages/ese/EseSesiones";
import EseResultados from "./pages/ese/EseResultados";
import EseMatriz from "./pages/ese/EseMatriz";
import EsePanel from "./pages/ese/EsePanel";
import EseDashboard from "./pages/ese/EseDashboard";
import EsePlanesHs from "./pages/ese/EsePlanesHs";
import EsePlanHsDetalle from "./pages/ese/EsePlanHsDetalle";
import EseReasignaciones from "./pages/ese/EseReasignaciones";
import CapacitadorReasignaciones from "./pages/capacitador/CapacitadorReasignaciones";
import CapacitadorNotificaciones from "./pages/capacitador/CapacitadorNotificaciones";
import CapacitadorAdminInputs from "./pages/capacitador/CapacitadorAdminInputs";
const KeyUserDocumentos = React.lazy(() => import("./pages/key_user/KeyUserDocumentos"));
const KeyUserEmpresa = React.lazy(() => import("./pages/key_user_empresa/KeyUserEmpresa"));
const KeyUserAuditoria = React.lazy(() => import("./pages/key_user/KeyUserAuditoria"));
const KeyUserOrganigrama = React.lazy(() => import("./pages/key_user/KeyUserOrganigrama"));
import { PlanificadorLayout } from "./components/PlanificadorLayout";
import ActividadesLista from "./pages/planificador/ActividadesLista";
import ActividadForm from "./pages/planificador/ActividadForm";
import ActividadDetalle from "./pages/planificador/ActividadDetalle";
import RegistroAcciones from "./pages/planificador/RegistroAcciones";
import GanttActividades from "./pages/planificador/GanttActividades";
import GestionUsuarios from "./pages/GestionUsuarios";
import MantenedorPersonas from "./pages/planificador/MantenedorPersonas";
import CatalogoRiesgos from "./pages/planificador/CatalogoRiesgos";
import DashboardPlanificador from "./pages/planificador/DashboardPlanificador";
import RoleSelector from "./components/RoleSelector";
import { AprobadorLayout } from "./components/AprobadorLayout";
import AprobadorActividades from "./pages/aprobador/AprobadorActividades";
import AprobadorDetalle from "./pages/aprobador/AprobadorDetalle";

const ProtectedRoute = ({ children }) => {
  const { user, loading, needsRoleSelection } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-teal-500"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Bloquear acceso a rutas administrativas para usuarios no admin
  // (trabajadores, ESE, capacitadores tienen sus propias rutas dedicadas)
  if (user.tipo === 'key_user') {
    return <Navigate to="/key-user/documentos" replace />;
  }
  if (user.tipo === 'key_user_contratista') {
    return <Navigate to="/key-user-empresa/documentos" replace />;
  }
  if (user.rol === 'trabajador' || user.tipo === 'trabajador') {
    return <Navigate to="/perfil-viewer" replace />;
  }
  if (user.rol === 'ese') {
    return <Navigate to="/ese/dashboard" replace />;
  }

  // All users must select a module first (except planificador who goes direct)
  if (user.rol !== 'planificador' && user.rol !== 'planificador_liderazgo' && user.rol !== 'pases_visita' && needsRoleSelection()) {
    return <Navigate to="/seleccionar-rol" replace />;
  }

  return <Layout>{children}</Layout>;
};

// Wrapper sin Layout para el rol "pases_visita" — solo deben ver su panel
const PasesVisitaProtected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-teal-500"></div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.rol !== 'pases_visita' && user.rol !== 'administrador') {
    return <Navigate to="/login" replace />;
  }
  return children;
};

const PublicRoute = ({ children }) => {
  const { user, loading, needsRoleSelection } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-teal-500"></div>
      </div>
    );
  }

  if (user) {
    if (user.rol === 'planificador') {
      return <Navigate to="/planificador" replace />;
    }
    if (user.rol === 'planificador_liderazgo') {
      return <Navigate to="/liderazgo" replace />;
    }
    if (user.rol === 'ese') {
      return <Navigate to="/ese/dashboard" replace />;
    }
    if (user.rol === 'pases_visita') {
      return <Navigate to="/pases-visita" replace />;
    }
    if (user.rol === 'servicios_generales') {
      return <Navigate to="/servicios-generales" replace />;
    }
    if (user.rol === 'equipo_hs') {
      return <Navigate to="/equipo-hs/eventos" replace />;
    }
    if (user.rol === 'trabajador' || user.tipo === 'trabajador') {
      // Excepción: si el usuario eligió perfil Reporte de Incidente, va al wizard
      if (user.tipo === 'reporte_incidente') {
        return <Navigate to="/incidentes" replace />;
      }
      return <Navigate to="/perfil-viewer" replace />;
    }
    if (needsRoleSelection()) {
      return <Navigate to="/seleccionar-rol" replace />;
    }
    if (user.rol === 'capacitador') {
      return <Navigate to="/capacitador/dashboard" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

// Portal routes for workers - Now uses main AuthContext
const PortalRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-teal-500"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <PortalLayout>{children}</PortalLayout>;
};

// Ruta genérica para el módulo Reporte de Incidente:
// accesible por trabajadores, ESE, capacitador o admin sin redirección forzada.
const IncidenteRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-teal-500"></div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const CapacitadorRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-teal-500"></div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (user.rol !== 'capacitador' && user.rol !== 'administrador') return <Navigate to="/dashboard" replace />;

  return <CapacitadorLayout>{children}</CapacitadorLayout>;
};

const SgRoute = () => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-slate-50"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500"></div></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.rol !== 'servicios_generales' && user.rol !== 'administrador') return <Navigate to="/dashboard" replace />;
  return <ServiciosGeneralesLayout />;
};

const EquipoHsRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-slate-50"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-rose-500"></div></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.rol !== 'equipo_hs' && user.rol !== 'administrador') return <Navigate to="/dashboard" replace />;
  return <EquipoHsLayout>{children}</EquipoHsLayout>;
};

const EseRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.rol !== 'ese' && user.rol !== 'administrador') return <Navigate to="/dashboard" replace />;
  return <EseLayout>{children}</EseLayout>;
};

const KeyUserRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-amber-500"></div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  // Permitir solo Key User (tipo='key_user') o admin
  if (user.tipo !== 'key_user' && user.rol !== 'administrador') {
    return <Navigate to="/perfil-viewer" replace />;
  }
  return children;
};

const KeyUserContratistaRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-teal-500"></div>
      </div>
    );
  }
  // Fallback: si user aún no se actualizó tras applyPerfil, leer del sessionStorage
  let effective = user;
  if (!effective || effective.tipo !== 'key_user_contratista') {
    try {
      const cached = JSON.parse(sessionStorage.getItem('cached_user') || 'null');
      if (cached?.tipo === 'key_user_contratista') effective = cached;
    } catch (e) { /* ignore */ }
  }
  if (!effective) return <Navigate to="/login" replace />;
  if (effective.tipo !== 'key_user_contratista' && effective.rol !== 'administrador') {
    return <Navigate to="/perfil-viewer" replace />;
  }
  return children;
};

const PlanificadorRoute = ({ children }) => {
  const { user, loading, activeRole } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-emerald-500"></div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  const hasPlanAccess = user.rol === 'planificador' || user.rol === 'administrador' ||
    (user.rol === 'trabajador' && activeRole === 'planificador' && (user.es_planificador || (user.modules && user.modules.includes(8))));
  if (!hasPlanAccess) return <Navigate to="/dashboard" replace />;
  return <PlanificadorLayout>{children}</PlanificadorLayout>;
};

const AprobadorRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-slate-50"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500"></div></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.rol !== 'aprobador' && user.rol !== 'administrador') return <Navigate to="/dashboard" replace />;
  return <AprobadorLayout>{children}</AprobadorLayout>;
};

const SessionWarningBanner = () => {
  const { showSessionWarning } = useAuth();
  if (!showSessionWarning) return null;
  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-red-600 text-white text-center py-2 text-sm font-medium shadow-lg animate-pulse">
      Su sesion se cerrara en 30 segundos por inactividad. Mueva el mouse o presione una tecla para continuar.
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <SessionWarningBanner />
          <Routes>
            {/* Login Unificado (presentación + form) */}
            <Route
              path="/login"
              element={
                <PublicRoute>
                  <Suspense fallback={<div />}><Presentacion loginMode={true} /></Suspense>
                </PublicRoute>
              }
            />
            {/* Login clásico, fallback (sin presentación) */}
            <Route
              path="/login-clasico"
              element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              }
            />
            <Route path="/verificar-checklist/:id" element={<Suspense fallback={<div />}><VerificarChecklist /></Suspense>} />
            <Route path="/implementacion_ti" element={<Suspense fallback={<div />}><ImplementacionTI /></Suspense>} />
            <Route path="/implementacion-ti" element={<Suspense fallback={<div />}><ImplementacionTI /></Suspense>} />
            <Route path="/pase-visita" element={<Suspense fallback={<div />}><PaseVisita /></Suspense>} />
            <Route path="/prueba/:sesionId" element={<Suspense fallback={<div />}><PruebaPublica /></Suspense>} />
            <Route path="/tutorial-key-user" element={<Suspense fallback={<div />}><TutorialKeyUser /></Suspense>} />
            <Route path="/validar-induccion-visita" element={<Suspense fallback={<div />}><ValidarPase /></Suspense>} />
            <Route path="/validar-pase" element={<Suspense fallback={<div />}><ValidarPase /></Suspense>} />
            <Route path="/pases-visita" element={
              <PasesVisitaProtected>
                <Suspense fallback={<div />}><PasesVisitaDashboard /></Suspense>
              </PasesVisitaProtected>
            } />
            
            {/* Role Selection for workers with planificador attribute */}
            <Route path="/seleccionar-rol" element={<RoleSelector />} />
            <Route path="/seleccionar-perfil" element={<SeleccionarPerfil />} />
            <Route path="/organigrama-viewer" element={<OrganigramaViewer />} />
            <Route path="/capacitacion-viewer" element={<CapacitacionViewer />} />
            <Route path="/documentos-viewer" element={<Suspense fallback={<div />}><DocumentosViewer /></Suspense>} />
            <Route path="/incidentes" element={<IncidenteRoute><Suspense fallback={<div />}><ReporteIncidente /></Suspense></IncidenteRoute>} />
            <Route path="/incidentes/editar/:id" element={<IncidenteRoute><Suspense fallback={<div />}><ReporteIncidente /></Suspense></IncidenteRoute>} />
            <Route path="/incidentes/mis" element={<IncidenteRoute><Suspense fallback={<div />}><MisIncidentes /></Suspense></IncidenteRoute>} />
            <Route path="/herramientas-viewer" element={<Suspense fallback={<div />}><HerramientasViewer /></Suspense>} />
            <Route path="/perfil-viewer" element={<Suspense fallback={<div />}><PerfilViewer /></Suspense>} />
            <Route path="/centro-datos" element={<Suspense fallback={<div />}><CentroDatos /></Suspense>} />
            <Route path="/liderazgo" element={<Suspense fallback={<div />}><LiderazgoDashboard /></Suspense>} />
            <Route path="/liderazgo-viewer" element={<Suspense fallback={<div />}><LiderazgoViewer /></Suspense>} />
            <Route path="/presentacion" element={<Suspense fallback={<div />}><Presentacion /></Suspense>} />

            {/* Admin Routes */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/organigrama"
              element={
                <ProtectedRoute>
                  <Organigrama />
                </ProtectedRoute>
              }
            />
            <Route
              path="/mapa"
              element={
                <ProtectedRoute>
                  <MapaAreas />
                </ProtectedRoute>
              }
            />
            <Route
              path="/areas"
              element={
                <ProtectedRoute>
                  <Areas />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sectores"
              element={
                <ProtectedRoute>
                  <Sectores />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cargos"
              element={
                <ProtectedRoute>
                  <Cargos />
                </ProtectedRoute>
              }
            />
            <Route
              path="/personas"
              element={
                <ProtectedRoute>
                  <Personas />
                </ProtectedRoute>
              }
            />
            <Route
              path="/controles"
              element={
                <ProtectedRoute>
                  <Controles />
                </ProtectedRoute>
              }
            />
            <Route
              path="/riesgos"
              element={
                <ProtectedRoute>
                  <Controles />
                </ProtectedRoute>
              }
            />
            <Route
              path="/capacitaciones"
              element={
                <ProtectedRoute>
                  <Capacitaciones />
                </ProtectedRoute>
              }
            />
            <Route
              path="/actividades"
              element={
                <ProtectedRoute>
                  <Actividades />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reportes"
              element={
                <ProtectedRoute>
                  <Reportes />
                </ProtectedRoute>
              }
            />
            <Route
              path="/configuracion"
              element={
                <ProtectedRoute>
                  <Configuracion />
                </ProtectedRoute>
              }
            />
            <Route path="/usuarios" element={<ProtectedRoute><GestionUsuarios /></ProtectedRoute>} />
            <Route
              path="/carga-masiva"
              element={
                <ProtectedRoute>
                  <CargaMasiva />
                </ProtectedRoute>
              }
            />
            <Route
              path="/repositorio"
              element={
                <ProtectedRoute>
                  <Repositorio />
                </ProtectedRoute>
              }
            />
            <Route
              path="/organizacion"
              element={
                <ProtectedRoute>
                  <Organizacion />
                </ProtectedRoute>
              }
            />
            <Route
              path="/qra"
              element={
                <ProtectedRoute>
                  <QRA />
                </ProtectedRoute>
              }
            />
            <Route
              path="/empresas-colaboradoras"
              element={
                <ProtectedRoute>
                  <EmpresasColaboradoras />
                </ProtectedRoute>
              }
            />
            <Route
              path="/informe-gcom"
              element={
                <ProtectedRoute>
                  <InformeGCOM />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reportes-gcom"
              element={
                <ProtectedRoute>
                  <ReportesGCOM />
                </ProtectedRoute>
              }
            />

            <Route
              path="/calendario-capacitaciones"
              element={
                <ProtectedRoute>
                  <CalendarioCapacitaciones />
                </ProtectedRoute>
              }
            />
            <Route
              path="/perfil-contratista"
              element={
                <ProtectedRoute>
                  <PerfilContratista />
                </ProtectedRoute>
              }
            />

            {/* Capacitador Routes */}
            <Route path="/capacitador/dashboard" element={<CapacitadorRoute><CapacitadorDashboard /></CapacitadorRoute>} />
            <Route path="/capacitador/calendario" element={<CapacitadorRoute><CapacitadorCalendario /></CapacitadorRoute>} />
            <Route path="/capacitador/cursos" element={<CapacitadorRoute><CapacitadorCursos /></CapacitadorRoute>} />
            <Route path="/capacitador/empresas" element={<CapacitadorRoute><CapacitadorEmpresas /></CapacitadorRoute>} />
            <Route path="/capacitador/reporte" element={<CapacitadorRoute><CapacitadorReporte /></CapacitadorRoute>} />
            <Route path="/capacitador/reglas" element={<CapacitadorRoute><CapacitadorReglas /></CapacitadorRoute>} />
            <Route path="/capacitador/bloqueados" element={<CapacitadorRoute><CapacitadorBloqueados /></CapacitadorRoute>} />
            <Route path="/capacitador/reasignaciones" element={<CapacitadorRoute><CapacitadorReasignaciones /></CapacitadorRoute>} />
            <Route path="/capacitador/notificaciones" element={<CapacitadorRoute><CapacitadorNotificaciones /></CapacitadorRoute>} />
            <Route path="/capacitador/admin-inputs" element={<CapacitadorRoute><CapacitadorAdminInputs /></CapacitadorRoute>} />
            <Route path="/capacitador/usuarios-por-empresa" element={<Navigate to="/capacitador/empresas" replace />} />

            {/* Servicios Generales */}
            <Route path="/servicios-generales/casino-kiosko" element={<SgCasinoKiosko />} />
            <Route path="/sg-qr/:numero" element={<SgQrHabitacion />} />
            <Route path="/servicios-generales" element={<SgRoute />}>
              <Route index element={<SgDashboard />} />
              <Route path="contratos" element={<SgContratos />} />
              <Route path="trabajadores" element={<SgTrabajadores />} />
              <Route path="casino" element={<SgCasino />} />
              <Route path="casino-reporte" element={<SgCasinoReporte />} />
              <Route path="habitaciones" element={<SgHabitaciones />} />
              <Route path="pabellones" element={<SgPabellones />} />
              <Route path="personal-soporte" element={<SgPersonalSoporte />} />
              <Route path="casino-mantenedor" element={<SgCasinoMantenedor />} />
              <Route path="timeline" element={<SgTimeline />} />
              <Route path="reglas" element={<SgReglas />} />
            </Route>
            <Route path="/capacitador/encuesta" element={<CapacitadorRoute><CapacitadorEncuesta /></CapacitadorRoute>} />

            {/* Equipo HS (HS Safework) */}
            <Route path="/equipo-hs" element={<Navigate to="/equipo-hs/eventos" replace />} />
            <Route path="/equipo-hs/eventos" element={<EquipoHsRoute><Suspense fallback={<div />}><EquipoHsEventos /></Suspense></EquipoHsRoute>} />
            <Route path="/equipo-hs/correos" element={<EquipoHsRoute><Suspense fallback={<div />}><EquipoHsCorreos /></Suspense></EquipoHsRoute>} />
            <Route path="/equipo-hs/planes-hs" element={<EquipoHsRoute><EsePlanesHs /></EquipoHsRoute>} />
            <Route path="/equipo-hs/planes-hs/:id" element={<EquipoHsRoute><EsePlanHsDetalle /></EquipoHsRoute>} />

            {/* ESE (Empresa Colaboradora) Routes */}
            <Route path="/ese/trabajadores" element={<EseRoute><EseTrabajadores /></EseRoute>} />
            <Route path="/ese/usuarios" element={<EseRoute><EseUsuarios /></EseRoute>} />
            <Route path="/ese/sesiones" element={<EseRoute><EseSesiones /></EseRoute>} />
            <Route path="/ese/resultados" element={<EseRoute><EseResultados /></EseRoute>} />
            <Route path="/ese/matriz" element={<EseRoute><EseMatriz /></EseRoute>} />
            <Route path="/ese/panel" element={<EseRoute><EsePanel /></EseRoute>} />
            <Route path="/ese/planes-hs" element={<EseRoute><EsePlanesHs /></EseRoute>} />
            <Route path="/ese/planes-hs/:id" element={<EseRoute><EsePlanHsDetalle /></EseRoute>} />
            <Route path="/ese/reasignaciones" element={<EseRoute><EseReasignaciones /></EseRoute>} />
            <Route path="/ese/dashboard" element={<EseRoute><EseDashboard /></EseRoute>} />
            <Route path="/key-user/documentos" element={
              <KeyUserRoute>
                <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-amber-500" /></div>}>
                  <KeyUserDocumentos />
                </Suspense>
              </KeyUserRoute>
            } />
            <Route path="/key-user/auditoria" element={
              <KeyUserRoute>
                <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-amber-500" /></div>}>
                  <KeyUserAuditoria />
                </Suspense>
              </KeyUserRoute>
            } />
            <Route path="/key-user/organigrama" element={
              <KeyUserRoute>
                <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-amber-500" /></div>}>
                  <KeyUserOrganigrama />
                </Suspense>
              </KeyUserRoute>
            } />

            {/* Key User Contratista (gestiona su empresa) */}
            <Route path="/key-user-empresa/documentos" element={
              <KeyUserContratistaRoute>
                <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-teal-500" /></div>}>
                  <KeyUserEmpresa initialTab="documentos" />
                </Suspense>
              </KeyUserContratistaRoute>
            } />
            <Route path="/key-user-empresa/organigrama" element={
              <KeyUserContratistaRoute>
                <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-teal-500" /></div>}>
                  <KeyUserEmpresa initialTab="organigrama" />
                </Suspense>
              </KeyUserContratistaRoute>
            } />

            {/* Planificador Routes */}
            <Route path="/planificador/actividades" element={<PlanificadorRoute><ActividadesLista /></PlanificadorRoute>} />
            <Route path="/planificador/actividades/nueva" element={<PlanificadorRoute><ActividadForm /></PlanificadorRoute>} />
            <Route path="/planificador/actividades/:id" element={<PlanificadorRoute><ActividadDetalle /></PlanificadorRoute>} />
            <Route path="/planificador/areas" element={<PlanificadorRoute><Areas /></PlanificadorRoute>} />
            <Route path="/planificador/sectores" element={<PlanificadorRoute><Sectores /></PlanificadorRoute>} />
            <Route path="/planificador/tipos-actividad" element={<PlanificadorRoute><TiposActividad /></PlanificadorRoute>} />
            <Route path="/planificador/recursos" element={<PlanificadorRoute><CatalogoRecursos /></PlanificadorRoute>} />
            <Route path="/planificador/personas" element={<PlanificadorRoute><MantenedorPersonas /></PlanificadorRoute>} />
            <Route path="/planificador/riesgos" element={<PlanificadorRoute><CatalogoRiesgos /></PlanificadorRoute>} />
            <Route path="/planificador" element={<PlanificadorRoute><DashboardPlanificador /></PlanificadorRoute>} />
            <Route path="/planificador/registro" element={<PlanificadorRoute><RegistroAcciones /></PlanificadorRoute>} />
            <Route path="/planificador/gantt" element={<PlanificadorRoute><GanttActividades /></PlanificadorRoute>} />

            {/* Aprobador Routes */}
            <Route path="/aprobador/actividades" element={<AprobadorRoute><AprobadorActividades /></AprobadorRoute>} />
            <Route path="/aprobador/actividades/:id" element={<AprobadorRoute><AprobadorDetalle /></AprobadorRoute>} />

            {/* Portal del Trabajador Routes */}
            <Route
              path="/portal/dashboard"
              element={
                <PortalRoute>
                  <PortalDashboard />
                </PortalRoute>
              }
            />
            <Route
              path="/portal/curso/:cursoId"
              element={
                <PortalRoute>
                  <PortalCurso />
                </PortalRoute>
              }
            />
            <Route
              path="/portal/perfil"
              element={
                <PortalRoute>
                  <PortalPerfil />
                </PortalRoute>
              }
            />
            <Route
              path="/portal/organigrama"
              element={
                <PortalRoute>
                  <PortalOrganigrama />
                </PortalRoute>
              }
            />
            <Route
              path="/portal/historial"
              element={
                <PortalRoute>
                  <PortalHistorial />
                </PortalRoute>
              }
            />
            <Route
              path="/portal/repositorio"
              element={
                <PortalRoute>
                  <PortalRepositorio />
                </PortalRoute>
              }
            />
            <Route
              path="/portal/investigaciones"
              element={
                <PortalRoute>
                  <Suspense fallback={<div />}>
                    <PortalInvestigaciones />
                  </Suspense>
                </PortalRoute>
              }
            />
            {/* Redirigir /portal y /portal/login al login unificado */}
            <Route path="/portal/login" element={<Navigate to="/login" replace />} />
            <Route path="/portal" element={<Navigate to="/login" replace />} />

            {/* Default Routes */}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </AuthProvider>
  );
}

export default App;
